export { updateStoryStructure } from 'next-flight-server-reference-proxy-loader?id=7061f02733b2f62ce59dfe28543c4134d35966628d&name=updateStoryStructure!'